/*
 * vrtPublic.ts - Public Routes (No Authentication Required)
 */
import type { RouteRecordRaw } from 'vue-router';

const vrtPublic: RouteRecordRaw = {
  path: '/guest',
  name: 'vrtPublic',
  component: () => import('src/layouts/vclPublic.vue'),
  children: [
    {
      path: 'contact',
      name: 'vrtPublicContactUs',
      component: () => import('./vpgPublicContactUs.vue'),
      meta: {
        requiresAuth: false, // Explicitly mark as public
        title: 'Contact Us',
      },
    },
  ],
};

export default vrtPublic;
